import Repository from "./Repository";

const resource = "/api/v1/events/";

export default {
  getAthleteEvents(id) {
    let subUrl = `${resource}getall/playerEvents/${id}`;
    return Repository.sendReq({ method: "get", subUrl });
  },
  getUpcomingAthleteEvents(id) {
    let date = new Date();
    let subUrl = `${resource}getall/playerEvents/${id}?profileId=${id}&date[gte]=${date}`;
    return Repository.sendReq({ method: "get", subUrl });
  },
  getPastAthleteEvents(id) {
    let date = new Date();
    let subUrl = `${resource}getall/playerEvents?profileId=${id}&date[lte]=${date}`;
    return Repository.sendReq({ method: "get", subUrl });
  },

  postAthleteEvents(data, id) {
    let subUrl = `${resource}addPlayerEvent/${id}`;
    return Repository.sendReq({ method: "post", subUrl, data });
  },

  editAthleteEvents(data, id) {
    let subUrl = `${resource}updatePlayerEvent/${id}`;
    return Repository.sendReq({ method: "patch", subUrl, data });
  },

  deleteAthleteEvents(id) {
    let subUrl = `${resource}deletePlayerEvent/${id}`;
    return Repository.sendReq({ method: "delete", subUrl });
  },

  // College Events
  getOneCollegeEvent(id) {
    let collegeId = localStorage.getItem("college-id");
    let subUrl = `${resource}getall/collegevents/${id}/${collegeId}`;
    return Repository.sendReq({ method: "get", subUrl });
  },
  getUpcomingCollegeEvents(id) {
    let collegeId = localStorage.getItem("college-id");
    let date = new Date();
    let subUrl = `${resource}getall/collegevents/${id}?collegeId=${collegeId}&date[gte]=${date}&page=1`;
    return Repository.sendReq({ method: "get", subUrl });
  },

  getPastCollegeEvents(id) {
    let collegeId = localStorage.getItem("college-id");
    let date = new Date();
    let subUrl = `${resource}getall/collegevents/${id}?collegeId=${collegeId}&date[lte]=${date}&page=1`;
    return Repository.sendReq({ method: "get", subUrl });
  },

  postCollegeEvents(data) {
    let subUrl = `${resource}addCollegeEvent`;
    return Repository.sendReq({ method: "post", subUrl, data });
  },
  editCollegeEvents(data, id) {
    let subUrl = `${resource}updateCollegeEvent/${id}`;
    return Repository.sendReq({ method: "patch", subUrl, data });
  },
  deleteCollegeEvents(id, data) {
    let subUrl = `${resource}deleteCollegeEvent/${id}`;
    return Repository.sendReq({ method: "delete", subUrl, data });
  },

  // Club Events
  getOneClubEvent(id) {
    let collegeId = localStorage.getItem("club-id");
    let subUrl = `${resource}getall/clubevents/${id}/${collegeId}`;
    return Repository.sendReq({ method: "get", subUrl });
  },
  getUpcomingClubEvents(id) {
    let date = new Date();
    let subUrl = `${resource}getall/clubevents/${id}?date[gte]=${date}&page=1`;
    return Repository.sendReq({ method: "get", subUrl });
  },

  getPastClubEvents(id) {
    let date = new Date();
    let subUrl = `${resource}getall/clubevents/${id}?date[lte]=${date}&page=1`;
    return Repository.sendReq({ method: "get", subUrl });
  },

  postClubEvents(data) {
    let subUrl = `${resource}addClubEvent`;
    return Repository.sendReq({ method: "post", subUrl, data });
  },
  editClubEvents(data, id) {
    let subUrl = `${resource}updateClubEvent/${id}`;
    return Repository.sendReq({ method: "patch", subUrl, data });
  },
  deleteClubEvents(id) {
    let subUrl = `${resource}deleteClubEvent/${id}`;
    return Repository.sendReq({ method: "delete", subUrl });
  }
};
